var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Проект")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedProject,
                    expression: "selectedProject",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedProject = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.loadProjectData,
                  ],
                },
              },
              [
                _c("option", { attrs: { value: "0", disabled: "" } }, [
                  _vm._v("Выберите проект"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.$AllProjects, function (p) {
                  return p.is_active
                    ? _c("option", { domProps: { value: p.id } }, [
                        _vm._v(_vm._s(p.title)),
                      ])
                    : _vm._e()
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group flex-grow-1" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Препарат")]),
              _vm._v(" "),
              _c("DrugSearchNew", {
                attrs: { onSelect: _vm.updateSelectedDrug },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? [
                !_vm.records.length
                  ? _c("div", { staticClass: "alert alert-info" }, [
                      _c("p", [
                        _vm._v("Не найдено ни одного вопроса, создайте новый"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "text-right mb-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info",
                      attrs: { type: "button" },
                      on: { click: _vm.addNewRecord },
                    },
                    [_vm._v("Добавить новый")]
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.records, function (r, i) {
                  return _c("div", { key: i, staticClass: "faq_block" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Вопрос")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.question,
                            expression: "r.question",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { rows: "2" },
                        domProps: { value: r.question },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(r, "question", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "" } }, [_vm._v("Ответ")]),
                        _vm._v(" "),
                        _c("HtmlEditor", {
                          ref: `answerEditor_${i}`,
                          refInFor: true,
                          attrs: { text: r.answer },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.status,
                            expression: "r.status",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: { type: "checkbox", id: `ch_${i}` },
                        domProps: {
                          checked: Array.isArray(r.status)
                            ? _vm._i(r.status, null) > -1
                            : r.status,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = r.status,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(r, "status", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    r,
                                    "status",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(r, "status", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: `ch_${i}` },
                        },
                        [_vm._v("запись активна")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        'Запись будет удалена с проекта в случае отметки "не активна"'
                      ),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm.records.length
                  ? _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Сохранить",
                            type: "button",
                            loading: _vm.btnLoading,
                            color: _vm.$constants.SUCCESS_COLOR,
                            onClick: () => _vm.updateRecords(),
                            className: "btn btn-outline-success",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v('Редактирование рубрик "вопрос/ответ" на проектах')]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }